'use strict';


import { getUrlParam } from '../../../functions';
import { getCurrentLang } from '../../components/langSwitcher/langSwitcher';
import { MathUtils, Spherical, Vector3 } from 'three';
import { Buildings, threeJsVariables } from '../../../settings';

const API_OPTIONS = {
	apiKey: config.googleAPI.split('&')[0],
	version: "beta",
	language: null,
	libraries: getUrlParam('dev') ? ["geometry","places","drawing"] : ["geometry","places"]
};

const MAP_OPTIONS = {
	"tilt": 30,
	"heading": 0,
	"zoom": 18,
	"center": { lat: 0, lng: 0 },
	"mapId": 'cea0f4a47d2b89ab',
	"disableDefaultUI": true,
	"zoomControl": false,
	"mapTypeControl": false,
	"scaleControl": false,
	"streetViewControl": false,
	"rotateControl": true,
	"fullscreenControl": false,
	"clickableIcons": false,
	"minZoom": 2,
	"maxZoom": 22,
	// "mapTypeControlOptions": {
	//     "mapTypeIds": ["satellite", "roadmap"]
	// },
	
	// "draggable": true
};


export class Google3DMap {
	constructor (cfg,parent,lat,lng,lang) {
		this.parent = parent;
		this.lang = lang || getCurrentLang();
		API_OPTIONS.language = this.lang;
		
		MAP_OPTIONS.center.lat = lat;
		MAP_OPTIONS.center.lng = lng;
		MAP_OPTIONS.minZoom = cfg.zoom.minZoom;
		MAP_OPTIONS.maxZoom = cfg.zoom.maxZoom;
		MAP_OPTIONS.zoom = cfg.zoom.default;
		
		if (cfg.hasOwnProperty('restricted') && cfg.restricted !== null) {
			MAP_OPTIONS.restriction = {
				latLngBounds: cfg.restricted,
				strictBounds: false,
			};
		}
		
		// this.#setInitialPosition();
		
		return this.loadGoogleMapScripts();
	}
	
	#setInitialPosition() {
		const target = new Vector3(
			threeJsVariables.bundleConfig.orbitControls.target.x,
			threeJsVariables.bundleConfig.orbitControls.target.y,
			threeJsVariables.bundleConfig.orbitControls.target.z
		);
		const camera = new Vector3(
			threeJsVariables.bundleConfig.camera.position.x,
			threeJsVariables.bundleConfig.camera.position.y,
			threeJsVariables.bundleConfig.camera.position.z
		);
		
		const direction = new Vector3().subVectors(camera,target).normalize();
		const spherical = new Spherical().setFromVector3(direction);
		const angle = MathUtils.radToDeg(spherical.theta);
		MAP_OPTIONS.heading = 360 - angle;
	}
	
	loadGoogleMapScripts() {
		return new Promise(async (resolve) => {
			const awaitInterval = setInterval(() => {
				const buildings = Buildings.getBuildingsArray();
				if (window.google && window.google.maps && buildings.length) {
					clearInterval(awaitInterval);
					const map = new google.maps.Map(this.parent, MAP_OPTIONS);
					
					function tilesLoaded () {
						google.maps.event.removeListener(listenerHandle);
						resolve(map);
					}
					
					const listenerHandle = google.maps.event.addListener(map, 'tilesloaded', tilesLoaded);
				}
			},300)
		});
	}
	
}

